<template>
	<div>
		<template v-if="exibirBotaoAdicionar">
			<div>
				<botao-adicionar id="botaoAdd" class="mb-3" type="button" @adicionar="openFileSelector">
					<template #label>
						<v-icon class="mr-1">archive</v-icon>
						{{ placeholder }}
					</template>
				</botao-adicionar>
				<tooltip-informacao
					v-if="exibirTooltip"
					class="ml-3 mt-1"
					:mensagem="textoTooltip"
				></tooltip-informacao>
			</div>
		</template>

		<az-file-upload
			v-model="model"
			v-validate="validate"
			:name="name"
			:placeholder="placeholder"
			:accept="extensoesPermitidas.join(',')"
			use-custom-behavior
			:height="height"
			:multiple="false"
			:error-messages="errors.collect(fieldErrorsMessage)"
			@upload-files="tratarEventoArquivoSelecionado"
			@drop.prevent="dragenter = false"
			@dragover.prevent="dragenter = true"
			@dragleave.prevent="dragenter = false"
		>
			<template #default>
				<slot></slot>
				<div v-if="showSelected">
					<div v-if="multiploArquivos">
						<div class="d-block">
							<v-icon>archive</v-icon>
							<h4 id="mensagemInput">Arraste seus arquivos aqui</h4>
						</div>
					</div>

					<div v-else>
						<div v-if="!model" class="d-block">
							<v-icon>archive</v-icon>
							<h4 id="mensagemInput">Arraste seu arquivo aqui</h4>
							<slot name="modelo"></slot>
						</div>
						<div v-else class="align-center d-flex flex-column justify-center">
							<div></div>
							<v-icon color="primary" class="mb-3" size="50">description</v-icon>
							<v-chip close small color="primary" @click:close="apagarAnexoSelecionado" @click.stop>
								<texto-tooltip :texto="model.name" :tamanho-maximo="20"></texto-tooltip>
							</v-chip>
						</div>
					</div>
				</div>
			</template>
		</az-file-upload>
		<div v-if="multiploArquivos" class="listagem-anexos">
			<div
				v-for="(item, index) in todosAnexos"
				class="align-center d-flex flex-column justify-center"
				:key="item.id"
			>
				<div class="listagem-anexos">
					<v-chip close small color="primary" @click:close="apagarAnexoSelecionadoDaLista(index)" @click.stop>
						<texto-tooltip :texto="item.name" :tamanho-maximo="20"></texto-tooltip>
					</v-chip>
				</div>
			</div>
		</div>
		<p id="hintInput" class="hint-input mb-0 mt-2">Tamanho máximo permitido: {{ tamanhoMaximo }}</p>
		<p v-if="erroObrigatoriedade" id="obrigatoriedadeAnexo" class="hint-input mb-0 mensagem-erro mt-0">
			O campo é obrigatório.
		</p>
		<div id="bottomComponent" class="bottom-component">
			<v-row class="d-flex flex-column" dense align="center" justify="center">
				<v-icon class="icon-bounce" size="70" color="primary">cloud_upload</v-icon>
				<div class="upload-area">
					<span class="texto-upload">{{ textoUpload }}</span>
				</div>
			</v-row>
		</div>
	</div>
</template>

<script>
import { mutationTypes } from '@/core/constants'

export default {
	name: 'campo-arquivo-novo',
	props: {
		anexosExistentes: {
			type: Array,
			default: () => [],
		},
		name: {
			required: true,
			type: String,
		},
		extensoesPermitidas: {
			type: Array,
			default() {
				return []
			},
		},
		placeholder: {
			type: String,
			default: 'Selecione',
		},
		errorUpload: {
			type: Boolean,
		},
		exibirBotaoAdicionar: {
			type: Boolean,
		},
		textoUpload: {
			type: String,
			default: 'Arraste e solte arquivos aqui',
		},
		height: {
			type: String,
			default: '150px',
		},
		showSelected: {
			type: Boolean,
		},
		scopeForm: {
			type: String,
			default: null,
		},
		validate: {
			type: Object,
			default() {
				return {}
			},
		},
		exibirTooltip: {
			type: Boolean,
		},
		textoTooltip: {
			type: String,
			default: '',
		},
		multiploArquivos: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			model: null,
			models: [],
			dragenter: false,
		}
	},
	computed: {
		tamanhoMaximo() {
			return this.$store.state.loki.file.maxSize
		},
		truncatedText() {
			let modelName = this.model.name

			if (!!modelName && modelName.length > 20) {
				return modelName.substring(0, 20) + '...'
			}
			return modelName
		},
		todosAnexos() {
			return [...this.anexosExistentes, ...this.models]
		},
		fieldErrorsMessage() {
			return this.scopeForm ? `${this.scopeForm}.${this.name}` : this.name
		},
		erroObrigatoriedade: {
			get() {
				return this.$store.state.campoArquivoNovo.erroObrigatoriedade
			},
			set(flag) {
				this.$store.commit(mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.SET_ERRO_OBRIGATORIEDADE_ARQUIVO, flag)
			},
		},
	},
	watch: {
		errorUpload(newValue) {
			if (!newValue) return
			if (this.multiploArquivos) this.models.pop()

			this.model = null
			this.$emit('update:error-upload', false)
		},
		dragenter(val) {
			this.showDragComponent(val)
		},
	},
	beforeDestroy() {
		this.erroObrigatoriedade = false
	},
	methods: {
		truncatedTextPorItem(item) {
			let modelName = item ? item.name : this.model.name

			if (!!modelName && modelName.length > 20) {
				return modelName.substring(0, 20) + '...'
			}
			return modelName
		},
		apagarAnexoSelecionado() {
			this.model = null
			this.erroObrigatoriedade = true

			this.$emit('apagar-anexo')
		},
		apagarAnexoSelecionadoDaLista(posicao) {
			const totalAntigos = this.anexosExistentes.length

			if (posicao >= totalAntigos) {
				const indexNosNovos = posicao - totalAntigos
				this.models.splice(indexNosNovos, 1)
			}

			this.$emit('apagar-anexo', posicao)
		},
		async openFileSelector() {
			const elemento = document.querySelector('.az-drop-file-container')
			elemento.click()
		},
		resetarValidacoes() {
			this.erroObrigatoriedade = false
		},
		async tratarEventoArquivoSelecionado(files) {
			if (this.multiploArquivos) {
				this.dragenter = false

				this.models.push(files[0])
				await this.tratarEnvioArquivoTemporario(files[0])
			} else {
				this.dragenter = false

				this.model = files[0]
				this.resetarValidacoes()
				const anexo = files[0]

				if (!anexo) {
					this.model = await null
					this.erroObrigatoriedade = true
				}

				await this.tratarEnvioArquivoTemporario(this.model)
			}
		},

		async tratarEnvioArquivoTemporario(model) {
			this.$emit('input', model)
		},

		showDragComponent(drag) {
			setTimeout(() => {
				const bottomComponent = document.querySelector('.bottom-component')
				drag ? bottomComponent.classList.add('visible') : bottomComponent.classList.remove('visible')
			}, 100)
		},
	},
}
</script>

<style scoped lang="stylus">
>>> .az-drop-file
	padding 0

	.center
		width 100% !important

.hint-input
	color #a5a5a5
	margin 0
	font-size 12px

.mensagem-erro
	color #FF5252

.bottom-component
	pointer-events none
	position fixed
	bottom -100%
	left 0
	right 0
	padding 20px
	transition bottom 0.3s ease-in-out
	z-index 999

.bottom-component.visible
	bottom 10%

.upload-area
	margin-top 15px
	width 300px
	height 70px
	background-color #0067a5
	border-radius 90px
	display flex
	justify-content center
	align-items center
	padding 20px

.texto-upload
	color white
	font-size 14px
	text-align center
	white-space pre-wrap

.icon-bounce
	display flex
	justify-content center
	align-items center
	background-color white
	width 28px
	height 35px
	animation bounce 1s infinite

	@keyframes bounce
		0%
			transform translateY(0)
		50%
			transform translateY(-10px)
		100%
			transform translateY(0)
.listagem-anexos
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-evenly;
	padding-top : 5px;
</style>
